import { useGetRequestOptions, UseGetRequestOptionsParams } from "./useGetRequestOptions";
import { SelectInputProps } from "../../../components/SortFilter/interfaces";

/**
	 * This is a shortcut to simply call useGetRequestOptions specifying that the options should be formatted
	 * for use in a select input, which includes normalizing the options to have `value` and `label` keys
	 *
	 * @param useGetRequestOptionsParams - Configuration for the underlying `useGetRequestOptions` hook
	 * @returns An object containing:
	 * - `options`: an array of normalized `SelectInputProps` items including the default "All" option;
	 * - `isLoading`: a boolean indicating whether the request is currently in progress;
	 * - `error`: any error returned by the underlying request, or `undefined`/`null` if none.
	 */

const useGetRequestSelectOptions = (useGetRequestOptionsParams: UseGetRequestOptionsParams) => {

  const {
    options,
    isLoading,
    error
  } = useGetRequestOptions({
    ...useGetRequestOptionsParams,
    optionFormat: 'SELECT'
  });

  return {
    options: options as unknown as SelectInputProps[],
    isLoading,
    error
  };
}

export { useGetRequestSelectOptions };
